<template>
  <div v-if="hasCaseRef">
    <table class="table table-striped table-sm mb-4">
      <tbody>
        <tr
          v-for="(val, key) in summary"
          :key="key"
        >
          <th scope="row">
            {{ $t(`recordList.${key}`) }}
          </th>
          <td v-if="key === 'address'">
            {{ val }}
            <br>
            <a
              target="_blank"
              :href="`https://www.google.com/maps/search/?api=1&amp;query=${encodeURIComponent(val)}`"
            >
              Open adres in Google Maps <i class="icon fa-fw fal fa-arrow-up-right-from-square" />
            </a>
          </td>
          <td v-else>
            {{ val }}
          </td>
        </tr>
      </tbody>
    </table>
    <DocDownload :uuid="uuid" />
    <div v-if="hasCaseRef && isNotCompleted">
      <RealisationStatusPanel
        :key="componentKey"
        class="mt-5 mb-5"
        :uuid="uuid"
        @update-component="componentKey++"
      />
      <RealisationDelete
        class="my-4"
        :uuids="[uuid]"
      />
    </div>
  </div>
  <b-alert
    v-else
    show
    variant="info"
  >
    {{ $t('processes.sidebar.save_location_proposal') }}
  </b-alert>
</template>

<script>

import RealisationStatusPanel from '@/components/realisation/RealisationStatusPanel.vue'
import RealisationDelete from '@/components/realisation/RealisationDelete.vue';
import DocDownload from '@/components/realisation/DocDownload.vue';
import recordList from '@/helpers/recordList'
import { mapGetters } from 'vuex'

export default {
  name: 'RealisationSidebarPrivateTab',
  components: {
    RealisationStatusPanel,
    DocDownload,
    RealisationDelete
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters('tenant', [
      'getLabelsByPidUuid'
    ]),
    uuid() {
      return this.record.uuid
    },
    hasCaseRef() {
      return !!this.record.case_ref
    },
    isNotCompleted() {
      return !this.record.status.completed && !this.record.status.locked
    },
    location() {
      try {
        return this.record.CurrentLocation
      } catch (e) {
        return {}
      }
    },

    locationRef() {
      return this.hasCaseRef ? `${this.record.case_ref}-${this.location.version}` : '-';
    },

    setCustomer () {
      const customer = this.location?.Object?.Address?.Customer
      return recordList.setCustomerValue({ fieldValue: customer })
    },

    summary() {
      if (!this.hasCaseRef) {
        return {

        }
      }

      try {
        let pid = this.location?.Application?.PidUuid
        let summary = {
          // RVB
          ...(this.location?.Object?.Address?.StreetName && { address: this.location?.Object?.Address?.StreetName + ' ' + this.location?.Object?.Address?.HouseNumber + ' ' + this.location?.Object?.Address?.CityName }),
          ...(this.getLabelsByPidUuid[pid] && { PidUuid: this.getLabelsByPidUuid[pid] }),
          ...(this.location?.Object?.Address?.BuildingCode && { BuildingCode: this.location?.Object?.Address?.BuildingCode }),
          ...(this.location?.Object?.Address?.RVBRegion && { Region: this.location?.Object?.Address?.RVBRegion }),
          ...(this.location?.Object?.Address?.Customer && { Customer: this.setCustomer }),
          // Gebouwen & Terreinen
          ...(this.location?.Object?.ProjectName && { ProjectName: this.location?.Object?.ProjectName }),
          ...(this.location?.Object?.ProjectNumber && { ProjectNumber: this.location?.Object?.ProjectNumber }),
          ...(this.location.Stakeholders.Customer && { Customer: this.location.Stakeholders.Customer }),
          reference: this.record.case_ref
        }

        return summary
      } catch (e) {
        console.log(e)

        return {}
      }
    }
  }
}
</script>
